import React from 'react';
import { Empty } from 'antd';
import { t } from 'ttag';

export interface Props {
  description?: string;
}

const NotFoundContent = ({ description = t`No results found` }: Props) => (
  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} />
);

export default NotFoundContent;
